import {fireChangeEvent} from "../../../default/global/js/utilities/fireEvent";
import {updateFilterViews} from "../custom/filter";
import {decodedLinks} from "../custom/decodedLinks";

function setActiveValueFilterItem(input, selectedTrigger, dropdownItems, value = "") {
    input.value = value;
    const filterAction = input.closest(".filterItem").querySelector(".filterItem__filterAction");
    let selectedText = "";
    let hasActive = false;
    for (let item of dropdownItems) {
        if (item.dataset.value === value || item.classList.contains("filterItem__dropdownItem--radio") && item.dataset.value === filterAction.value) {
            item.classList.add("is-active");
            selectedText = item.querySelector('.filterItem__dropdownItemHeadline').innerHTML;
            hasActive = true;
        } else {
            item.classList.remove("is-active");
        }
    }
}

function setActiveValueFilterItemMultiple(input, selectedTrigger, dropdownItems) {
    let currentValues = input.value.split("|");
    let countSelected = selectedTrigger.querySelector('.filterItem__selectedCount');
    let hasActive = false;
    for (let item of dropdownItems) {
        if (currentValues.includes(item.dataset.value)) {
            item.classList.add("is-active");
            hasActive = true;
        } else {
            item.classList.remove("is-active");
        }
    }
    currentValues = currentValues.filter(Boolean);
    if (currentValues[0] === "UNSET") {
        currentValues = [];
    }
    if (countSelected) {
        if (currentValues.length > 0) {
            countSelected.classList.add("is-active");
            countSelected.innerHTML = currentValues.length;
        } else {
            countSelected.classList.remove("is-active");
        }
    }
    if (!hasActive) {
        input.value = 'UNSET';
    }
}

export function initFilterItems(wrapper = document) {
    for (let filterItem of wrapper.querySelectorAll(".js-filterItem")) {
        const input = filterItem.querySelector("input.filterItem__hiddenFormField");
        const selectedTrigger = filterItem.querySelector('.filterItem__selected');
        const dropdown = filterItem.querySelector(".filterItem__dropdown");
        const dropdownItems = dropdown.querySelectorAll('.filterItem__dropdownItem:not(.disabled)');
        const splitter = "|";

        const isMultiple = filterItem.classList.contains("filterItem--multiple");
        const isRangeAsCheckboxes = filterItem.classList.contains("filterItem--range-as-checkboxes");

        const isRadio = filterItem.querySelector(".filterItem__dropdownItem--radio") !== null;

        let filterAction = filterItem.querySelector(".filterItem__filterAction");
        let sortBy = filterItem.querySelector(".filterItem__sortBy");

        function sendFilterActionByAjax(){
            let itemListView = document.querySelector(".itemListView");
            if(itemListView){
                itemListView.classList.add("is-loading");
            }
            const oldUrl = window.location.href;
            let newUrl = "";
            let updateUrl = false;

            // Request the filtered list straight as GET. Submitting the form as POST only
            // made the server redirect back to this same URL to turn the posted filter-action
            // into the query string, which cost an extra round trip on every filter click.
            fetch('?' + filterAction.value, {
                method: 'GET',
                headers: {'X-DC-Filter-Ajax': '1'}
            })
                .then(response => {
                    // With the header above the server renders the canonical filter page
                    // directly instead of redirecting to it, and names that URL here. Resolve
                    // it against the current location so it stays comparable to oldUrl.
                    const canonical = response.headers.get('X-DC-Canonical-Url');
                    newUrl = canonical
                        ? new URL(canonical, window.location.href).href
                        : response.url;
                    updateUrl = (oldUrl !== newUrl);
                    if (!response.ok) {
                        throw new Error('Fehlerhafte Server-Antwort');
                    }
                    return response.text();
                })
                .then(data => {
                    const responseHtml = new DOMParser().parseFromString(data, 'text/html');
                    updateFilterViews(responseHtml,updateUrl);
                    if (filterAction.value.includes('UNSET')) {
                        // use the final URL of the server redirect (without the query) so
                        // removing a filter also leaves an indexable filter page URL
                        window.history.pushState({}, '', newUrl ? newUrl.split('?')[0] : window.location.pathname);
                    } else if (updateUrl) {
                        window.history.pushState({}, '', newUrl);
                    }
                    decodedLinks();
                    setTimeout(function () {
                        const activeFiltersHeadline = document.querySelector('.activeFilters__headline');
                        if (activeFiltersHeadline) {
                            activeFiltersHeadline.focus();
                        }
                    }, 0);
                })
                .catch(error => {
                    console.error('Ajax-Fehler:', error);
                });
        }

        function resetFilterItem(){
            input.value = 'UNSET';
            filterAction.value = input.name + '=' + input.value + '&' + sortBy.name + '=' + sortBy.value;
            if(isRangeAsCheckboxes){
                filterAction.value = input.name + '_from=' + input.value + '&' + input.name + '_to=' + input.value + '&' + sortBy.name + '=' + sortBy.value;
            }
            if (isMultiple) {
                setActiveValueFilterItemMultiple(input, selectedTrigger, dropdownItems);
            } else if (isRadio) {
                setActiveValueFilterItem(input, selectedTrigger, dropdownItems, 'UNSET');
                fireChangeEvent(input);
            } else {
                setActiveValueFilterItem(input, selectedTrigger, dropdownItems, "");
                fireChangeEvent(input);
            }
        }

        function updateFilterItem(dropdownItem){
            let value = dropdownItem.dataset.value;
            if (value) {
                if (isMultiple) {
                    if (dropdownItem.classList.contains("is-active")) {
                        let currentValues = '';
                        if (input.value !== 'UNSET') {
                            currentValues = input.value.split(splitter);
                            let index = currentValues.indexOf(value);
                            currentValues.splice(index, 1);
                            input.value = currentValues.join(splitter);
                        } else {
                            input.value = value;
                        }
                    } else {
                        if (input.value !== 'UNSET') {
                            let currentValues = input.value.split(splitter);
                            currentValues.push(value);
                            input.value = currentValues.join(splitter);
                        } else {
                            input.value = value;
                        }
                    }
                    filterAction.value = input.name + '=' + input.value + '&' + sortBy.name + '=' + sortBy.value;
                    setActiveValueFilterItemMultiple(input, selectedTrigger, dropdownItems);
                }else if (isRangeAsCheckboxes){
                    if (dropdownItem.classList.contains("is-active")) {
                        value = dropdownItem.dataset.code + "_from=UNSET&"+dropdownItem.dataset.code + "_to=UNSET";
                    }
                    input.value = value;
                    filterAction.value = input.value + '&' + sortBy.name + '=' + sortBy.value;
                    setActiveValueFilterItem(input, selectedTrigger, dropdownItems, value);
                } else if (isRadio) {
                    if (dropdownItem.classList.contains("is-active")) {
                        value = 'UNSET';
                        input.value = value;
                        filterAction.value = input.name + '=' + value + '&' + sortBy.name + '=' + sortBy.value;
                    } else {
                        input.value = value;
                        filterAction.value = input.value + '&' + sortBy.name + '=' + sortBy.value;
                    }
                    setActiveValueFilterItem(input, selectedTrigger, dropdownItems, value);
                } else {
                    setActiveValueFilterItem(input, selectedTrigger, dropdownItems, value);
                    fireChangeEvent(input);
                }
                const filterItemActiveItems = filterItem.querySelectorAll(".filterItem__dropdownItem.is-active");
                if(filterItemActiveItems.length === 0){
                    resetFilterItem();
                }
                sendFilterActionByAjax();
                decodedLinks();
            }
        }

        if (input && selectedTrigger && dropdown) {
            if (dropdownItems) {
                if (isMultiple) {
                    setActiveValueFilterItemMultiple(input, selectedTrigger, dropdownItems);
                } else {
                    setActiveValueFilterItem(input, selectedTrigger, dropdownItems, input.value);
                }
                for (let dropdownItem of dropdownItems) {
                    dropdownItem.addEventListener("click", function () {
                        updateFilterItem(dropdownItem);
                    });
                }
            }
        }
    }
}